
import Login from './components/login/Login.vue';

import LessonWrapper from './components/lesson/LessonWrapper.vue';

import Top from './components/lesson/Top.vue';

import LessonRegion from './components/lesson/LessonRegion.vue';
import LessonIntroduction from './components/lesson/LessonIntroduction.vue';
import LessonGrammar from './components/lesson/LessonGrammar.vue';
import LessonPractice from './components/lesson/LessonPractice.vue';
import LessonReview from './components/lesson/LessonReview.vue';
import LessonListeningPractice from './components/lesson/LessonListeningPractice.vue';
import LessonScript from './components/lesson/LessonScript.vue';
import LessonExam from './components/lesson/LessonExam.vue';
import LessonExplanation from './components/lesson/LessonExplanation.vue';

import Profile from './components/profile/Profile.vue';
import EditProfile from './components/profile/edit-profile/EditProfile.vue';
import EditEmail from './components/profile/edit-email/EditEmail.vue';
import EditPassword from './components/profile/edit-password/EditPassword.vue';

import Situation from './components/profile/Situation.vue';
import SituationDetail from './components/profile/SituationDetail.vue';

import NoticeWrapper from './components/notice/NoticeWrapper.vue';
import NoticeList from './components/notice/NoticeList.vue';
import NoticeDetail from './components/notice/NoticeDetail.vue';

import Levels from './components/shared/Levels.vue';

// register
import Trial from './components/singup/Trial.vue';
import Expired from './components/singup/Expired.vue';

import BlockSignup from './components/singup/BlockSignup.vue';

// stripe
import Purchase from './components/stripe/Purchase.vue';
import PurchaseFinished from './components/stripe/PurchaseFinished.vue';

import SubscriptionDetail from './components/stripe/SubscriptionDetail.vue';
// Inquiry
import InquiryWrapper from './components/inquiry/InquiryWrapper.vue';
import InquiryList from './components/inquiry/InquiryList.vue';
import InquiryMessage from './components/inquiry/InquiryMessage.vue';


export default [
  {
    path: '/apps',
    name: 'apps',
    redirect: {
      name: 'top'
    }
  },
  {
    path: '/apps/login',
    name: 'login',
    component: Login,
    meta: {requiresGuest: true}
  },
  {
    path: '/apps/blocksignup',
    name: 'blocksignup',
    component: BlockSignup,
    meta: {requiresGuest: true}
  },
  {
    path: '/apps/trial',
    name: 'apps.trial',
    component: Trial,
    meta: {requiresAuth: true }
  },
  {
    path: '/apps/expired',
    name: 'apps.expired',
    component: Expired,
    meta: {requiresAuth: true }
  },
  {
    path: '/apps/purchase',
    component: LessonWrapper,
    children: [
      {
        path: '',
        name: 'apps.purchase',
        component: Purchase,
        meta: {requiresAuth: true}
      },
      {
        path: 'finished',
        name: 'apps.purchase.finished',
        component: PurchaseFinished,
        meta: {requiresAuth: true }
      }
    ]
  },
  {
    path: '/apps/top',
    component: LessonWrapper,
    children: [
      {
        path: '',
        name: 'top',
        component: Top,
        meta: {requiresAuth: true}
      },
      {
        path: ':level',
        name: 'top.level',
        component: Top,
        meta: {requiresAuth: true},
        props: true
      }
    ]
  },
  {
    path: '/apps/lesson',
    component: LessonWrapper,
    children: [
      {
        path: ':region',
        name: 'region',
        component: LessonRegion,
        meta: {requiresAuth: true},
        props: true
      },
      {
        path: ':lesson_id/introduction',
        name: 'lesson.introduction',
        component: LessonIntroduction,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/grammar',
        name: 'lesson.grammar',
        component: LessonGrammar,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/practice',
        name: 'lesson.practice',
        component: LessonPractice,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/review',
        name: 'lesson.review',
        component: LessonReview,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/listening-practice',
        name: 'lesson.listening.practice',
        component: LessonListeningPractice,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/script',
        name: 'lesson.script',
        component: LessonScript,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/exam',
        name: 'lesson.exam',
        component: LessonExam,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/explanation/:step',
        name: 'lesson.explanation',
        component: LessonExplanation,
        meta: {requiresAuth: true},
        props: true
      }
    ]
  },
  {
    path: '/apps/profile',
    component: LessonWrapper,
    children: [
      {
        path: '',
        name: 'profile',
        component: Profile,
        props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'edit',
        name: 'profile.edit',
        component: EditProfile,
        meta: {requiresAuth: true}
      },
      {
        path: 'email',
        name: 'profile.email',
        component: EditEmail,
        meta: {requiresAuth: true}
      },
      {
        path: 'password',
        name: 'profile.password',
        component: EditPassword,
        meta: {requiresAuth: true}
      },
      {
        path: 'situation',
        name: 'profile.situation',
        component: Situation,
        meta: {requiresAuth: true},
        props: true,
        children: [
          {
            path: ':level',
            name: 'profile.situation.level',
            component: Situation,
            meta: {requiresAuth: true},
            props: true
          }
        ]
      },
      {
        path: 'situation/:level/detail/:category',
        name: 'profile.situation.detail',
        component: SituationDetail,
        meta: {requiresAuth: true},
        props: true
      },
      {
        path: 'subscription',
        name: 'profile.subscription',
        component: SubscriptionDetail,
        meta: {requiresAuth: true}
      },
      {
        path: '*',
        redirect: {
          name: 'profile'
        }
      }
    ]
  },
  {
    path: '/apps/levels',
    name: 'levels',
    component: Levels,
    meta: {requiresGuest: true}
  },
  {
    path: '/apps/notice',
    component: NoticeWrapper,
    children: [
      {
        path: '',
        name: 'notice',
        component: NoticeList,
        meta: {requiresAuth: true}
      },
      {
        path: ':news_id',
        name: 'notice.detail',
        component: NoticeDetail,
        meta: {requiresAuth: true}
      }
    ]
  },
  {
    path: '/apps/inquiry',
    component: InquiryWrapper,
    children: [
      {
        path: '',
        name: 'inquiry',
        component: InquiryList,
        meta: {requiresAuth: true}
      },
      {
        path: 'message',
        name: 'inquiry.message',
        component: InquiryMessage,
        meta: {requiresAuth: true}
      }
    ]
  }
];